export const mergePropClasses = (props, classes) =>
  mergeClasses([props.class || props.className].concat(classes));

export const mergeClasses = (classes) =>
  classes.filter((element) => typeof element === "string").join(" ");
